var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingLinkShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5693 0.0168736L0.2233 5.13343C0.160467 5.15433 0.105479 5.19385 0.0656432 5.24674C0.0258072 5.29964 0.00300915 5.3634 0.00027777 5.42956C-0.00245361 5.49572 0.0150112 5.56114 0.0503516 5.61714C0.0856921 5.67314 0.137235 5.71706 0.198132 5.74306L5.83763 8.16012C5.86718 8.17291 5.89954 8.17783 5.93156 8.1744C5.96358 8.17097 5.99416 8.15931 6.02033 8.14054L11.5489 4.1901C11.7204 4.06892 11.9311 4.27959 11.8099 4.4511L7.85946 9.97967C7.84101 10.0058 7.82961 10.0363 7.82634 10.0681C7.82307 10.0999 7.82806 10.1321 7.84081 10.1614L10.2569 15.8009C10.2829 15.8619 10.3267 15.9135 10.3826 15.9489C10.4386 15.9843 10.504 16.0018 10.5701 15.9992C10.6363 15.9966 10.7001 15.9739 10.753 15.9341C10.806 15.8944 10.8456 15.8395 10.8666 15.7767L15.9831 0.429815C16.0024 0.372293 16.0052 0.310542 15.9913 0.251497C15.9774 0.192451 15.9473 0.13845 15.9044 0.0955571C15.8616 0.0526644 15.8076 0.0225791 15.7485 0.00868002C15.6895 -0.0052191 15.6268 -0.00238172 15.5693 0.0168736Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingLinkShareIcon);
export default __webpack_public_path__ + "static/media/booking_link_share_icon.e12d6db4a9c6a424aae08f87d9cc7cdf.svg";
export { ForwardRef as ReactComponent };